import { ReactElement } from 'react'
import Layout from '../../components/layout'
import RegionList from '../../components/Region'

const RegionPage = (): ReactElement => {
  return (
    <Layout >
      <RegionList />
    </Layout>
  )
}
export default RegionPage
